const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const MarketingPreference = require('@/models/MarketingPreference');

class MarketingPreferenceRepository extends AbstractRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param marketingPreferenceResource
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        marketingPreferenceResource
    ) {
        super(
            dataStore,
            hydrator,
            syncStateManager
        );

        this.marketingPreferenceResource = marketingPreferenceResource;
    }

    /**
     * @protected
     */
    getEntityName() {
        return 'Marketing Preference';
    }

    /**
     * @protected
     */
    getEntityClass() {
        return MarketingPreference;
    }

    /**
     * @protected
     */
    getTableName() {
        return DataStoreNames.MARKETING_PREFERENCES;
    }

    /**
     * @protected
     * @return {{query: function(params: object, success:function, error:function)}}
     */
    getResource() {
        return this.marketingPreferenceResource;
    }

    /**
     * @return {Promise<MarketingPreference[]>}
     */
    findAllActive() {
        return super._findAllActive();
    }
}

module.exports = MarketingPreferenceRepository;
